import { useState } from "react";
import { API } from "../../../services/api";
import {
    EMPTY_PHARMACY_FORM,
    pharmacyEditPayload,
    pharmacyToEditForm,
    withAddedPartenaire,
    withoutPartenaireAt,
} from "../superAdminRules";

export function usePharmacyEditor(onSaved) {
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState(EMPTY_PHARMACY_FORM);
    const [editError, setEditError] = useState(null);
    const [editSaving, setEditSaving] = useState(false);
    const [newPartenaire, setNewPartenaire] = useState("");

    const startEdit = (p) => {
        setEditingId(p.id);
        setEditForm(pharmacyToEditForm(p));
        setNewPartenaire("");
        setEditError(null);
    };

    const addPartenaire = () => {
        const partenaires = withAddedPartenaire(editForm.partenaires, newPartenaire);
        if (!partenaires) return;
        setEditForm(f => ({ ...f, partenaires }));
        setNewPartenaire("");
    };

    const removePartenaire = (idx) => {
        setEditForm(f => ({ ...f, partenaires: withoutPartenaireAt(f.partenaires, idx) }));
    };

    const handleEdit = async (e) => {
        e.preventDefault();
        setEditError(null);
        setEditSaving(true);
        try {
            const { data } = await API.patch(`/super-admin/pharmacies/${editingId}`, pharmacyEditPayload(editForm));
            onSaved(editingId, data);
            setEditingId(null);
        } catch (err) {
            setEditError(err.response?.data?.message ?? "Erreur lors de la sauvegarde.");
        } finally {
            setEditSaving(false);
        }
    };

    return {
        editingId,
        editForm,
        setEditForm,
        editError,
        editSaving,
        newPartenaire,
        setNewPartenaire,
        startEdit,
        cancelEdit: () => setEditingId(null),
        addPartenaire,
        removePartenaire,
        handleEdit,
    };
}
